import { motion, AnimatePresence } from 'framer-motion';
import React from 'react';
export default function SavingOverlay() {
    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div
                    className="position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9998, cursor: 'wait', backgroundColor: 'transparent' }}
                />

                <motion.div
                    className="position-fixed top-0 start-0 w-100 shadow-lg"
                    style={{
                        zIndex: 9999,
                        background: 'var(--ink)',
                        borderBottom: '4px solid var(--accent)'
                    }}
                    initial={{ y: -100 }}
                    animate={{ y: 0 }}
                    exit={{ y: -100 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                >
                    <div className="container-fluid">
                        <div className="d-flex align-items-center justify-content-center py-3 position-relative">
                            {/* Animated Progress Line */}
                            <motion.div
                                className="position-absolute bottom-0 start-0"
                                style={{
                                    height: '4px',
                                    backgroundColor: 'var(--accent)',
                                    boxShadow: '0 0 20px rgba(199, 29, 150, 0.8)'
                                }}
                                initial={{ width: '0%' }}
                                animate={{ width: ['0%', '100%'] }}
                                exit={{ width: '100%' }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            />

                            {/* Spinner */}
                            <motion.div
                                className="me-3"
                                animate={{ rotate: 360 }}
                                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                            >
                                <div
                                    style={{
                                        width: '28px',
                                        height: '28px',
                                        borderRadius: '50%',
                                        border: '3px solid rgba(255, 255, 255, 0.3)',
                                        borderTopColor: 'var(--accent)',
                                    }}
                                />
                            </motion.div>

                            {/* Text */}
                            <div className="text-white">
                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                    Saving changes
                                </span>
                                <motion.span
                                    className="ms-1"
                                    animate={{ opacity: [0, 1, 0] }}
                                    transition={{ duration: 1.5, repeat: Infinity }}
                                >
                                    <span>.</span>
                                    <span>.</span>
                                    <span>.</span>
                                </motion.span>
                            </div>

                            {/* Pulsing Icon */}
                            <motion.i
                                className="fas fa-cloud-upload-alt ms-3"
                                style={{ color: 'var(--accent)', fontSize: '1.5rem' }}
                                animate={{
                                    scale: [1, 1.2, 1],
                                    opacity: [0.7, 1, 0.7]
                                }}
                                transition={{ duration: 1.5, repeat: Infinity }}
                            />
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}
